export const CommonTitlesConstant = {
  avg_players_number: 'AVG # of Players',
  total_players_number: 'Total # of Players',
};
